export default {
  title: 'ใบแจ้งรายได้ออนไลน์',
  home: 'หน้าหลัก',
  company: 'บริษัท',
  form: {
    guided: {
      documents: 'เอกสารและชื่อที่แสดง',
      access: 'อายุเอกสารและการเข้าถึง',
      displayName: 'ชื่อที่แสดง',
      noExpiry: '0 = ไม่หมดอายุ'
    },
    'pay-slip': 'สลิปเงินเดือน',
    tawi: '50 ทวิ',
    pnd: 'ภงด. 91',
    other: 'เมนู 4 ',
    'forgot-password': 'ปุ่มลืมรหัสผ่านเข้าสลิปเงินเดือน',
    'custom-placeholder': 'Custom Name',
    'expiry-days': 'อายุการใช้งาน (วัน) ใส่ 0 คือไม่มีขีดจำกัด'
  },
  'company-table': require('./CompanyTable.js').default
}
